import { render, staticRenderFns } from "./LabelledField.vue?vue&type=template&id=09262f7c&scoped=true"
import script from "./LabelledField.vue?vue&type=script&setup=true&lang=js"
export * from "./LabelledField.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LabelledField.vue?vue&type=style&index=0&id=09262f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09262f7c",
  null
  
)

export default component.exports